export default "__VITE_PUBLIC_ASSET__98fc4900__"